var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23198_49737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2474 9.99984L8.7474 12.4998L13.7474 7.49984M18.3307 9.99984C18.3307 14.6022 14.5998 18.3332 9.9974 18.3332C5.39502 18.3332 1.66406 14.6022 1.66406 9.99984C1.66406 5.39746 5.39502 1.6665 9.9974 1.6665C14.5998 1.6665 18.3307 5.39746 18.3307 9.99984Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23198_49737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIconCircle);
export default __webpack_public_path__ + "static/media/complete-icon-circle.2e33eaed254c023a549217cd7eeaf33e.svg";
export { ForwardRef as ReactComponent };